import type { IIndustryCodesFilterDto } from "app/pages/sales-intelligence/domain/industry/types/filter-values";
import { type InclusionOption, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

export class IndustryCodesFilterValue {
    public readonly inclusion: InclusionOption;
    public readonly sicCodes: readonly string[];
    public readonly naicsCodes: readonly string[];

    static readonly defaultInclusion: InclusionOption = inclusionOptionMap.includeOnly;

    constructor(value?: Partial<IIndustryCodesFilterDto>) {
        const dto = IndustryCodesFilterValue.toDtoValue(value);

        this.inclusion = dto.inclusion;
        this.sicCodes = dto.sicCodes;
        this.naicsCodes = dto.naicsCodes;
    }

    static toDtoValue(value: Partial<IIndustryCodesFilterDto> = {}): IIndustryCodesFilterDto {
        const { sicCodes = [], naicsCodes = [], inclusion = IndustryCodesFilterValue.defaultInclusion } = value;

        return {
            inclusion,
            sicCodes,
            naicsCodes,
        };
    }

    with(partial: Partial<IIndustryCodesFilterDto>): IIndustryCodesFilterDto {
        return IndustryCodesFilterValue.toDtoValue({
            inclusion: this.inclusion,
            sicCodes: this.sicCodes,
            naicsCodes: this.naicsCodes,
            ...partial,
        });
    }

    isEmpty(): boolean {
        return this.sicCodes.length === 0 && this.naicsCodes.length === 0;
    }
}
